<template>
  <div class="modal_wrap system ic_commonModal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">질문 유형 선택</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="check_table">
              <label v-for="(item, index) in items" :key="index"
                ><input
                  type="radio"
                  name="sort"
                  :value="item"
                  v-model="selectedValue"
                /><span>{{ item.label }}</span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="close">닫기</button>
            <button class="btn2" @click="confirm">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="made_toast_layer_common" style="top:60%;" v-if="isViewToast">
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'community-category-modal',
  description: '커뮤니티 > 지식인 카테고리 팝업',
  props: {
    show: Boolean,
    value: [Object, String],
  },
  data(props) {
    return {
      items: [
        { label: '휴대폰', value: 'MOBILE' },
        { label: '인터넷', value: 'INTERNET' },
        { label: '알뜰폰', value: 'MVNO' },
        { label: '요금제', value: 'PLAN' },
        { label: '렌탈', value: 'RENTAL' },
        { label: '매장', value: 'STORE' },
      ],
      selectedValue: props.value,
      isViewToast: false,
      errorMessage: '',
    };
  },
  methods: {
    close() {
      this.selectedValue = this.value;
      this.$emit('close');
    },
    confirm() {
      if (!this.selectedValue) {
        this.errorMessage = '질문유형을 선택해주세요';
        this.toastView();
        return;
      }
      this.$emit('close', this.selectedValue);
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
  },
};
</script>
